const CHECKOUT_BASE =
  'https://football-ready-system-365.impultienda.ar/checkout'

// UTM / tracking params we want to forward from the landing page URL to the
// checkout so attribution (and UTMify) is preserved through the sale.
const FORWARD_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'src',
  'sck',
  'xcod',
  'fbclid',
  'gclid',
  'ttclid',
]

/**
 * Builds the checkout URL, forwarding any UTM / tracking parameters
 * present in the current page URL.
 */
export function buildCheckoutUrl(): string {
  if (typeof window === 'undefined') return CHECKOUT_BASE
  try {
    const current = new URLSearchParams(window.location.search)
    const url = new URL(CHECKOUT_BASE)
    for (const key of FORWARD_PARAMS) {
      const value = current.get(key)
      if (value) url.searchParams.set(key, value)
    }
    return url.toString()
  } catch {
    return CHECKOUT_BASE
  }
}
